import * as React from "react";
import TextField, { TextFieldProps } from "@mui/material/TextField";
import Autocomplete from "@mui/material/Autocomplete";

export interface OptionType {
  inputValue?: string;
  title: string;
}

interface CreateOptionSelectProps {
  options: OptionType[];
  value: OptionType | null;
  inputValue?: string;
  onChange: (value: OptionType | null) => void;
  onInputChange?: (value: string) => void;
}

const CreateOptionSelect = React.forwardRef<
  HTMLInputElement,
  CreateOptionSelectProps &
    Omit<TextFieldProps, "options" | "onChange" | "value">
>(({ options, value, inputValue, onChange, onInputChange, ...inputProps }, ref) => {
  return (
    <Autocomplete
      value={value}
      inputValue={inputValue}
      onChange={(event, newValue) => {
        if (typeof newValue === "string") {
          onChange({
            title: newValue,
          });
        } else if (newValue?.inputValue) {
          onChange({
            title: newValue.inputValue,
          });
        } else {
          onChange(newValue);
        }
      }}
      onInputChange={(event, value, reason) => {
        if (reason !== 'reset') {
          onInputChange?.(value)
        }
      }}
      filterOptions={(options) => options}
      selectOnFocus
      handleHomeEndKeys
      autoHighlight
      includeInputInList
      options={options}
      isOptionEqualToValue={(option, selectedValue) =>
        option.title === selectedValue.title
      }
      getOptionLabel={(option) => {
        if (typeof option === "string") {
          return option;
        }
        if (option.inputValue) {
          return option.inputValue;
        }
        return option.title;
      }}
      renderOption={(liProps, option) => {
        const { key, ...rest } = liProps
        return <li key={key} {...rest}>{option.title}</li>
      }}
      freeSolo
      fullWidth
      renderInput={(params) => (
        <TextField
          {...params}
          {...inputProps}
          fullWidth
          inputRef={ref}
        />
      )}
    />
  );
});

CreateOptionSelect.displayName = "CreateOptionSelect";

export default CreateOptionSelect;
